import { Component } from '@angular/core';
import { Platform } from '@ionic/angular';
import { Capacitor } from '@capacitor/core'; 
import { AppUpdate } from '@ionic-native/app-update/ngx';
import { WORDPRESS_URL } from './config';
import { SplashScreen } from '@capacitor/splash-screen';
import { StorageService } from './services/storage.service';
import { SwUpdate } from '@angular/service-worker';
import { Router } from '@angular/router';
import {App} from '@capacitor/app';
import { LoadingService } from './services/loading.service';
import { AuthenticationService } from './services/authentication.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent {
  
  constructor(   
    private platform: Platform,      
    private appUpdate: AppUpdate,
    private storage: StorageService,
    private loading: LoadingService,
    private swUpdate: SwUpdate,
    private router: Router,
    private authenticationService: AuthenticationService
  ) {
    this.initializeApp();   
  }

  private exit_click_count:number = 0;

  async ngOnInit() {   
    this.swUpdate.available.subscribe(async _ => {
      console.log("SW Update available");
      const toast = await this.loading.presentToast("Update available! Page will reload", 3000);
      toast
        .onDidDismiss()
        .then(() => this.swUpdate.activateUpdate())
        .then(() => window.location.reload())
        .then(() => console.log("SW Update applied"));
    });
    this.swUpdate.checkForUpdate();
    setInterval(() => {
      this.swUpdate.checkForUpdate();
    } , 15 * 60 * 1000);
  }

  async checkStorage() {   
    console.log("Checking if storage reset is necessary");
    let lastReset = await this.storage.get("LAST_RESET");    
    if(!lastReset) {
      await this.storage.set("LAST_RESET", Date.now());
      return;
    }
    let diff = Date.now() - lastReset;
    if(diff/(1000*60*60*24*2) > 2) { // 1000*60*60*24*2 ms = 2 days      
      await this.storage.clearStorageWithoutLogout(this.authenticationService.getCurrentUser);
      await this.storage.set("LAST_RESET", Date.now());
      console.log("Storage reset after 2 days");
    }    
  }

  checkVersion() {
    const updateUrl = WORDPRESS_URL + 'myapp/app_update.xml';
    this.appUpdate.checkAppUpdate(updateUrl).then(
      (_) => {                          
      }).catch(error=>{
        console.log("Error during App Version Check: "+error.msg);
      });
  }
 
  async initializeApp() { 

     //As alternative check
    //https://github.com/ionic-team/ionic-framework/issues/18759

    this.platform.backButton.subscribeWithPriority(-1, () => {
      if (this.router.url == "/menu/home" || this.router.url == "/menu/messages" || this.router.url == "/menu/login") {
        setTimeout(
          () => {
            this.exit_click_count = 0;            
          }, 2000) 
        if(this.exit_click_count >= 1) {    
          App.exitApp();
        } else {
          this.loading.presentToast("Click again to close App", 2000);
          this.exit_click_count++;        
        }        
      }
    });

    this.platform.ready().then(() => { 
      SplashScreen.hide();     
    });
    this.platform.resume.subscribe((res) => {
      console.log('App resumed main');
      //this.checkStorage(); 
      if(Capacitor.isNativePlatform()) {
        console.log("Checking version");
        this.checkVersion();
      } else {      
        console.log("No version check as no native runtime");
      }
    }); 
  }    
}
